import { Component, computed, OnInit, Signal } from '@angular/core';
import * as moment from 'moment';
import {
  DATETIMEFORMART,
  UserInformation,
} from 'src/app/interfaces/interfaces';
import { ApiService } from 'src/app/services/api-services/api.service';
import { DatetimeFormatService } from 'src/app/services/datetime-format-service/datetime-format.service';
import { UserStore } from 'src/app/stores/user.store';

@Component({
  selector: 'app-working-hours-widget',
  templateUrl: './working-hours-widget.component.html',
  styleUrls: ['./working-hours-widget.component.scss'],
})
export class WorkingHoursWidgetComponent implements OnInit {
  workingHours = this.userStore.user()?.workingHours;
  weekdays: Signal<{ value: string; active: boolean; stringName: string }[]> = computed(() => this.updateWeekdaysFormat(this.dateTimeFormat()));
  dateTimeFormat = this.dateTimeService.selectedDateTimeFormat;
  constructor(
    private apiService: ApiService,
    private dateTimeService: DatetimeFormatService,
    private userStore: UserStore
  ) {}

  ngOnInit() {
      this.weekdays().forEach(
        (weekday, index) =>
          (weekday.active = this.workingHours.daysOfWeek.includes(index + 1)
            ? true
            : false)
      );
  }

  updateWeekdaysFormat(dateTimeFormat: string) {
    const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    const dayValues = [1, 2, 3, 4, 5, 6, 0]; // Monday is 1, Sunday is 0

    return days.map((day, index) => {
      const date = new Date();
      const currentDay = date.getDay();
      const diff = dayValues[index] - currentDay;
      date.setDate(date.getDate() + diff);

      const formattedDayName = date.toLocaleDateString(dateTimeFormat, {
        weekday: 'short',
      });

      return {
        value: day,
        active: this.workingHours?.daysOfWeek?.includes(index + 1) ? true : false,
        stringName: formattedDayName,
      };
    });
  }
}
